import type { ComponentStyle } from "@yamada-ui/core"

export const Text: ComponentStyle<"Text"> = {}
